import { useMemo } from 'react';

import { makeFullHeadMprSliceRecordViews } from '@/shared/graphics/medicalImageRender/MedicalImageRender';
import { useAppSelector } from '@/shared/hooks';

import { reportsModel } from '@/entities/reports';

import type { FullHeadMprSliceRecordViewsByTileID } from '../config';

export const useToothFullHeadMprSliceRecords = (
  toothID: string,
): FullHeadMprSliceRecordViewsByTileID => {
  const slices = useAppSelector(
    reportsModel.selectors.selectFullHeadMprSlicesByToothID(toothID),
  );

  return useMemo(
    () => makeFullHeadMprSliceRecordViews({ slices, toothID }),
    [slices, toothID],
  );
};
